import axiosBase from "@/api/axiosBase";

const state = {
  importList_data: "",
  importList_case_data: "",
  importDelete_data: "",
  deleteTemplate_data: "",
  importCreate_data: "",
  importCreate_template_data: "",
  importDelete_case_data: "",
  getTemplateData: "",
  listTemplate_data: "",
  listAllTemplate_data: "",
  updateTemplate_data: "",
  listUpload_data: "",
  deleteUpload_data: "",
  exportloadModel_data: "",
  downloadModel_data: "",
}

const getters = {
}

const mutations = {


  // 导入模型-创建模型
  setImportCreate(state, data) {
    state.importCreate_data = data
  },
  // 导入模型-创建模型（新版）
  setImportCreate_template(state, data) {
    state.importCreate_template_data = data
  },

  // 导入模型-删除上传的模型案例文件
  setImportDalete(state, data) {
    state.importDelete_data = data
  },
  // 导入模型-删除上传的模型案例文件（新版）
  setImportDalete_case(state, data) {
    state.importDelete_case_data = data
  },

  // 删除指定的模板模型
  setDeleteTemplate(state, data) {
    state.deleteTemplate_data = data
  },

  // 获取文件列表
  setGetTemplate(state, data) {
    state.getTemplateData = data
  },

  // 导入模型-列出上传的模型案例文件
  setImportList(state, data) {
    state.importList_data = data
  },
  // 导入模型-列出上传的模型案例文件（新版）
  setImportList_case(state, data) {
    state.importList_case_data = data
  },

  // 列出专用模型模板
  setListTemplate(state, data) {
    state.listTemplate_data = data
  },

  // 列出所有模型模板-包括常规模型模板
  setListAllTemplate(state, data) {
    state.listAllTemplate_data = data
  },

  // 修改已有模板模型
  setUpdateTemplate(state, data) {
    state.updateTemplate_data = data
  },

  setListUpload(state, data) {
    state.listUpload_data = data
  },

  setDeleteUpload(state, data) {
    state.deleteUpload_data = data
  },

  setExportModel(state, data) {
    state.exportloadModel_data = data
  },

  setDownloadModel(state, data) {
    state.downloadModel_data = data
  },

}


const actions = {
  // 导入模型-创建模型
  importCreate({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/import/create',
        data: {
          "case_name": data.case_name,
          "group_id": data.group_id,
          "model_name": data.model_name,
          "template": data.template,
          // "timeout": 0
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setImportCreate', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },
  // 导入模型-创建模型（新版）
  importCreate_template({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/template/create_template',
        data: {
          "case_name": data.case_name,
          "permission_option": data.permission_option,
          "remark": data.remark,
          "share_with": data.share_with,
          "template_name": data.template_name,
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setImportCreate_template', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 导入模型-删除上传的模型案例文件
  importDelete({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/import/delete/' + data.case_name,
        data: {
          "case_name": data.case_name
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setImportDalete', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },
  // 导入模型-删除上传的模型案例文件（新版）
  importDelete_case({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/template/delete_case',
        data: {
          "case_name": data.case_name
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setImportDalete_case', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 删除指定的模板模型
  deleteTemplate({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/template/delete_template',
        data: {
          "template_id": data
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setDeleteTemplate', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取模板模型数据
  getTemplate({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/model/template/get_template',
        params: {
          "template_id": data
        },

      })
        .then(res => {          
          if (res.data.code != 200) {
            
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setGetTemplate', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 导入模型-列出上传的模型案例文件
  importList({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/import/list',
        data: null
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setImportList', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },
  // 导入模型-列出上传的模型案例文件（新版）
  importList_case({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/model/template/list_case',
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setImportList_case', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 列出专用模型模板
  listTemplate({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/model/template/list_template',
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setListTemplate', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 列出所有模型模板-包括常规模型模板
  listAllTemplate({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/model/template/list_template_all',
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setListAllTemplate', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 修改已有模板模型
  updateTemplate({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/template/modify_template',
        data: {
          "permission_option": data.permission_option,
          "remark": data.remark,
          "share_with": data.share_with,
          "template_name": data.template_name,
          "template_id": data.template_id
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setUpdateTemplate', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 创建模型
  createModel({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/import/create',
        data: {
          "case_name": data.case_name,
          "group_id": data.group_id,
          "model_name": data.model_name
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setCreateModel', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 列出上传的模型
  listUpload({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/import/list',
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setListUpload', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 删除上传的模型
  deleteUpload({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/import/delete',
        data: {
          "case_name": data.case_name
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setDeleteUpload', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 导出模型
  exportModel({ dispatch, commit }, data) {
    return axiosBase({
      method: 'POST',
      url: '/model/retrieve/export',
      data: {
        "model_id": data.model_id
      },
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: "blob",
    })

  },

  // 下载模型
  downloadModel({ dispatch, commit }, data) {
    return axiosBase({
      method: 'POST',
      url: '/model/retrieve/download',
      data: {
        "model_id": data.model_id,
        "with_result": data.with_result
      },
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: "blob",
    })
  },

  // 检查上传文件大小是否超过限制
  checkUploadSize({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: "/basedata/check_upload_size?size=" + data,
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 导出hru文件
  exportHru({ dispatch, commit }, data) {
    return axiosBase({
      method: 'GET',
      url: '/model/build/subbasin_hru_download?model_id=' + data.model_id,
      // data: {
      //   "model_id": data.model_id
      // },
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: "blob",
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

